"use client";

import { FC } from "react";
import {
  chakra,
  Checkbox as ChakraCheckbox,
  CheckboxRootProps,
} from "@chakra-ui/react";
import { checkboxControlRecipe, checkboxLabelRecipe } from "./checkbox.recipe";

export const CheckboxRoot = ChakraCheckbox.Root;
export const CheckboxHiddenInput = ChakraCheckbox.HiddenInput;
export const CheckboxLabel = chakra(ChakraCheckbox.Label, checkboxLabelRecipe);
export const CheckboxControl = chakra(
  ChakraCheckbox.Control,
  checkboxControlRecipe,
);

type Props = CheckboxRootProps & {
  dark?: boolean;
  simple?: boolean;
  onCheckedChange?: (details: { checked: boolean | "indeterminate" }) => void;
};

const Checkbox: FC<Props> = ({ simple, dark, children, ...props }) => (
  <CheckboxRoot {...props}>
    <CheckboxHiddenInput />
    <CheckboxControl visual={dark ? "dark" : undefined} />
    <CheckboxLabel visual={simple ? "simple" : undefined}>
      {children}
    </CheckboxLabel>
  </CheckboxRoot>
);

export default Checkbox;
